import { useEffect, useState } from 'react';
import {
  canAddJobs as canAddJobsUtil,
  canCreateScheduleAttainment as canCreateScheduleAttainmentUtil,
  canEditJobDetails as canEditJobDetailsUtil,
  canEditReferenceTables as canEditReferenceTablesUtil,
  canEditSharedFilter as canEditSharedFilterUtil,
  canUpdateJobOrder as canUpdateJobOrderUtil,
  canUpdateJobStatus as canUpdateJobStatusUtil,
  canViewCleanCalculations as canViewCleanCalculationsUtil,
  canViewProductCalculations as canViewProductCalculationsUtil,
  canViewReferenceTables as canViewReferenceTablesUtil,
  canViewScheduleAttainment as canViewScheduleAttainmentUtil,
  canViewScheduleCalculations as canViewScheduleCalculationsUtil,
  canViewSysproJobs as canViewSysproJobsUtil,
  hasPermission as hasPermissionUtil,
  isFieldDisabled as isFieldDisabledUtil
} from 'utils/AuthUtils/ppsAccessControl';
import { useStore } from './useStore';
import {toast} from 'react-toastify';

export const usePpsAccess = () => {
  const { UserStore } = useStore();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const environment = import.meta.env.VITE_ENVIRONMENT;

  useEffect(() => {
    const loadUserInfo = async () => {
      if (!UserStore.userMetadata) {
        try {
          await UserStore.fetchUserDetails();
        } catch (error) {
          if(environment === 'development'){
            console.error('Error fetching user details:', error);
          }
          toast.error('Error fetching user details');
        }
      }
      setIsLoading(false);
    };

    loadUserInfo();
  }, [UserStore]);

  return {
    isLoading,
    userRole: UserStore.ppsUserRole,
    userDepartment: UserStore.userDepartment,

    // Functions to check permissions
    hasPermission: (permission: string) =>
      hasPermissionUtil(permission as any, UserStore.userDepartment, UserStore.ppsUserRole),

    isFieldDisabled: (fieldName: string, isEditMode: boolean = false) =>
      isFieldDisabledUtil(fieldName, UserStore.userDepartment, UserStore.ppsUserRole, isEditMode),

    canEditJobDetails: () => canEditJobDetailsUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canUpdateJobStatus: () =>
      canUpdateJobStatusUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canUpdateJobOrder: () => canUpdateJobOrderUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    // For backward compatibility
    canEditJobs: () => canEditJobDetailsUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canAddJobs: () => canAddJobsUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canCreateScheduleAttainment: () =>
      canCreateScheduleAttainmentUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canViewScheduleAttainment: () =>
      canViewScheduleAttainmentUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canViewReferenceTables: () =>
      canViewReferenceTablesUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canEditReferenceTables: () =>
      canEditReferenceTablesUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canViewProductCalculations: () =>
      canViewProductCalculationsUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canViewCleanCalculations: () =>
      canViewCleanCalculationsUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canViewScheduleCalculations: () =>
      canViewScheduleCalculationsUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canViewSysproJobs: () => canViewSysproJobsUtil(UserStore.userDepartment, UserStore.ppsUserRole),

    canEditSharedFilter: () =>
      canEditSharedFilterUtil(UserStore.userDepartment, UserStore.ppsUserRole)
  };
};
